<template>
    <div>
        <el-card class="box-card">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/ClothStock' }">库存管理</el-breadcrumb-item>
                <el-breadcrumb-item>列表</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
        <el-card style="margin-top:20px"> 
            <el-row :gutter="10">
              <el-col :span="1.5">
                  <div class="grid-content bg-purple">
                      <span>款号:</span>
                  </div>
              </el-col>
              <el-col :span="5"
                  ><div class="grid-content bg-purple">
                      <el-input v-model="clothesName"  placeholder="请输入款号" clearable></el-input></div
              ></el-col>
              <el-col :span="10">
                  <el-button type="primary" icon="el-icon-search" @click="search()">查询</el-button>
              </el-col>
            </el-row>
            <el-table  :key="randomKey" :data="dataList" :span-method="tableSpanMethod" border style="width: 100%;margin:20px 0px" @cell-dblclick="editInputShow">
              <el-table-column prop="clothesName" label="款号"  width="180" align="center"></el-table-column>
              <el-table-column prop="clothesColor" label="颜色" align="center"></el-table-column>
              <el-table-column  v-for="item in tableHead" :key="item.value" :prop="item.value" :label="item.label" align="center">
                  <template slot-scope="scope">
                    <el-input v-if="scope.row[scope.column.property + 'isShow']" v-model="scope.row[scope.column.property]" 
                    :ref="scope.column.property" @blur="doHideInput(scope.row,scope.column)"></el-input>
                    <span v-else>{{scope.row[scope.column.property]}}</span>
                  </template>
              </el-table-column>
            </el-table>
            <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNo"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
      return {
          pageNo: 1,
          pageSize: 10,
          total: 0,
          clothesName: '',
          dataList: [],
          tableHead: [],
          remainIndex: 0,
          randomKey: Math.random(),
      }
    },
    created() {
        this.getClothesStockHead();
        this.getClothesStockList();
    },
    methods: {
         async getClothesStockHead() {
            const res = await this.$axios.post('manage/stock/getClothesStockHead');
            if(res.data.code == 0){
                this.tableHead = res.data.data;
            }
    
        },
        async getClothesStockList() {
            const res = await this.$axios.post('manage/stock/getClothesStockList', {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                clothesName: this.clothesName
            });
            if(res.data.code == 0){
                this.dataList = res.data.data;
                this.total = res.data.total;
            }else{
                this.$message.error(`${res.data.msg}`);
            }
    
        },
        tableSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                var thisRowData = this.dataList[rowIndex];
                var colorCount = thisRowData.colorCount;
                var dataRowIndex = thisRowData.rowIndex;
                if(colorCount == 1 && dataRowIndex == 1){
                     return {rowspan: 1,colspan: 1};
                }else {
                    if(colorCount > 1 && dataRowIndex == 1){
                        return {rowspan: colorCount,colspan: 1};
                    }else{
                        return {rowspan: 0,colspan: 0};
                    }
                }
            }
        },
        doHideInput(row,column) {
          var stockNumber = row[column.property]
          var intPattern = /^[0-9]+$/
          if(stockNumber == null){
            stockNumber = 0;
            row[column.property] = 0
          }
          if(!intPattern.test(stockNumber)){
             return this.$message.error('请输入正确的整数');
          }
          const res = this.$axios.post('manage/stock/updateClothesStock', {
                clothesId: row.clothesId,
                clothesColorId: row.clothesColorId,
                clothesSizeId:column.property,
                stockNumber: stockNumber
            });
          row[column.property + "isShow"] = false
          this.refreshTable()
        },
        editInputShow(row,column){
          if(column.property.indexOf('size') < 0){
              return;
          }
          row[column.property + "isShow"] = true
          this.refreshTable()
          this.$nextTick(() => {
            this.$refs[column.property][0].focus()
          })
        },
        refreshTable () {
          this.randomKey = Math.random()
        },

        handleSizeChange(pageSize) {
            this.pageNo = 1;
            this.pageSize = pageSize;
            this.getClothesStockList();
        },

        handleCurrentChange(pageNo) {
            this.pageNo = pageNo;
            this.getClothesStockList();
        },

        search() {
            this.pageNo = 1;
            this.getClothesStockList();
        },
    }
}
</script>

<style>

</style>